import React from "react";

import type { AuditFieldDiff } from "./auditTypes";
import {
  formatAuditRelationValue,
  humaniseKey,
  shouldDisplayAuditField,
} from "./auditFormatters";
import { RelationValueList } from "./auditValueDisplay";

type AuditRelationsSectionProps = {
  relations?: Record<string, AuditFieldDiff> | null;
};

export default function AuditRelationsSection({
  relations,
}: AuditRelationsSectionProps) {
  const entries = Object.entries(relations ?? {}).filter(([key]) =>
    shouldDisplayAuditField(key),
  );
  if (entries.length === 0) return null;

  return (
    <div className="mt-3">
      <p className="mb-1.5 text-xs font-semibold uppercase tracking-[0.08em] text-[#64748B]">
        Related changes
      </p>
      <div className="space-y-3">
        {entries.map(([key, diff]) => (
          <div key={key} className="text-sm">
            <p className="font-medium text-[#0F172A]">{humaniseKey(key)}</p>
            <div className="mt-1.5 flex flex-col gap-2 sm:flex-row sm:items-start sm:gap-3">
              <RelationValueList
                relationKey={key}
                value={diff?.from}
                variant="from"
                formatAuditRelationValue={formatAuditRelationValue}
              />
              <span className="hidden shrink-0 text-[#64748B] sm:inline">
                →
              </span>
              <RelationValueList
                relationKey={key}
                value={diff?.to}
                variant="to"
                formatAuditRelationValue={formatAuditRelationValue}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
